import axios from 'axios';

export function setHeader(url, authorization) {
  axios.defaults.baseURL = url;
  axios.defaults.headers.common.Authorization = authorization;
  axios.defaults.headers.common['Access-Control-Allow-Origin'] = '*';
}

export function query(resource, params = {}) {
  return axios.get(resource, {params})
    .catch((error) => {
      throw new Error(`ApiService (${resource}) ${error}`);
    });
}

export function get(resource, slug, params = {}) {
  return axios.get(`${resource}/${slug}`, {params})
    .catch((error) => {
      throw new Error(`ApiService (${resource}/${slug}) ${error}`);
    });
}

export function post(resource, params) {
  return axios.post(`${resource}`, params)
    .catch((error) => {
      throw new Error(`ApiService (${resource}) ${error}`);
    });
}

export function update(resource, slug, params) {
  return axios.patch(`${resource}/${slug}`, {params})
    .catch((error) => {
      throw new Error(`ApiService (${resource}/${slug}) ${error}`);
    });
}

export function destroy(resource) {
  return axios.delete(resource)
    .catch((error) => {
      throw new Error(`ApiService (${resource}) ${error}`);
    });
}

export default {
  setHeader,
  query,
  get,
  post,
  update,
  destroy,
};
